import { useForm } from 'react-hook-form';
import Button from 'src/components/atoms/button/button';
import { Form, FormError, FormItem, FormRow } from 'src/components/atoms/form';
import Label from 'src/components/atoms/label/label';
import { RootState, useAppDispatch, useAppSelector } from 'src/reducers';
import { validationSchema } from 'src/utils/validation-utils';
import { useNavigate, useParams } from 'react-router-dom';
import { resetPassword, resetPasswordState } from 'src/reducers/passwordReset.reducer';
import { useEffect } from 'react';
import Spinner from 'src/components/atoms/spinner/spinner';
import { Heading } from '../../atoms/heading/heading';

export const ResetPassword = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const navigate = useNavigate();

  const defaultValues = {
    password: '',
    confirmPassword: '',
    personalCode: params.personalCode,
  };

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues,
  });

  const { success, loading } = useAppSelector((state: RootState) => state.resetPassword);

  const checkPassword = e => {
    return e === getValues('password');
  };

  const onSubmit = data => {
    dispatch(resetPassword(data));
  };

  useEffect(() => {
    if (success) {
      navigate('/login');
      dispatch(resetPasswordState());
    }
  }, [success, success]);

  return (
    <div className="container sm m-auto">
      <Heading content="Reset password" size={2} className="mb-1" />
      <Form>
        <FormRow>
          <FormItem>
            <Label>Inserisci la tua nuova password</Label>
            <input
              type="password"
              placeholder="Nuova password"
              autoComplete="off"
              className={`form-control ${errors.password ? 'is-invalid' : ''}`}
              {...register('password', validationSchema.password)}
            />
            <FormError error={errors.password} validation={validationSchema.password} />
          </FormItem>
          <FormItem>
            <Label>Conferma la tua nuova password</Label>
            <input
              type="password"
              placeholder="Ripeti nuova password"
              autoComplete="off"
              className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
              {...register('confirmPassword', {
                ...validationSchema.confirmPassword,
                validate: {
                  match: e => checkPassword(e),
                },
              })}
            />
            <FormError error={errors.confirmPassword} validation={validationSchema.confirmPassword} />
          </FormItem>
        </FormRow>
        <FormRow>
          <FormItem>
            <Button
              onClick={handleSubmit(onSubmit)}
              size="md"
              rounded="rounded-md"
              color="light-grey"
              mode="outline"
              fullWidth
              disabled={!isValid || loading}
            >
              {loading ? <Spinner /> : 'Cambia password'}
            </Button>
          </FormItem>
        </FormRow>
      </Form>
    </div>
  );
};
